class ModalModule {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindEvents();
    }

    bindUI() {
        this.ui = {};

        this.ui.$body = document.body;
        this.ui.$modal = document.querySelector('.js-modal');
        this.ui.$modalClose = this.ui.$modal.querySelectorAll('.js-modal-close');
        this.ui.$modalTrigger = document.querySelectorAll('.js-modal-trigger');
    }

    bindEvents() {
        [].forEach.call(this.ui.$modalTrigger, ($trigger, index) => {
            $trigger.addEventListener('click', this.onClickModalTrigger.bind(this));
        });

        [].forEach.call(this.ui.$modalClose, ($close, index) => {
            $close.addEventListener('click', this.onClickModalClose.bind(this));
        });
    }

    onClickModalTrigger(e) {
        e.preventDefault();
        this.openModal();
    }

    onClickModalClose(e) {
        e.preventDefault();
        this.closeModal();
    }


    openModal() {
        if (this.ui.$modal) {
            this.ui.$modal.classList.add('is-visible');
            this.ui.$body.classList.add('is-unscrollable');
        }
    }

    closeModal() {
        if (this.ui.$modal) {
            this.ui.$modal.classList.remove('is-visible');
            this.ui.$body.classList.remove('is-unscrollable');
        }
    }
}

export default ModalModule;
